import PersonMedicationsSummary from './PersonMedicationsSummary';

export default PersonMedicationsSummary;
